import { motion } from "framer-motion";

const STORIES = [
  "Leo and the Whispering Starlight Fox",
  "Maya and the Kingdom of Floating Lanterns",
  "Oliver and the Secret Dragon Library",
  "Emma and the Moonlit Mermaid Cove",
  "Noah and the Wandering Constellation Map",
  "Sophia and the Sleepy Cloud Village",
  "Aiden and the Friendly Giant of Tumblebrook",
  "Lily and the Door That Wasn't There Yesterday",
  "James and the Cozy Moon Market",
  "Zoe and the Orchestra of Singing Stars",
];

const SYMBOL = "✦";

export default function EditorialMarquee() {
  const items = [...STORIES, ...STORIES];

  return (
    <div data-testid="editorial-marquee" className="relative py-5 border-y border-purple-500/15 overflow-hidden">
      {/* Left/right fade */}
      <div className="absolute left-0 top-0 bottom-0 w-24 z-10 pointer-events-none" style={{ background: "linear-gradient(to right, #0B091A, transparent)" }} />
      <div className="absolute right-0 top-0 bottom-0 w-24 z-10 pointer-events-none" style={{ background: "linear-gradient(to left, #0B091A, transparent)" }} />

      <div className="marquee-track">
        {items.map((title, i) => (
          <span key={i} className="inline-flex items-center gap-5 pr-10 whitespace-nowrap">
            <span className="text-amber-400/50 text-xs">{SYMBOL}</span>
            <span className="font-serif text-sm text-slate-400 hover:text-amber-300 transition-colors cursor-default">
              {title}
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}
